import React from 'react';
import {useSelector} from 'react-redux';

import * as localizationKeys from '../../consts/localization/localizationKeys';
import {getLocalizedStrings} from '../../services/localization/localizationService';
import appRouterService from '../../services/route/appRouterService';
import {makeSelectDeviceName} from '../../state/selectors/consumer';
import {selectIsDeviceReady} from '../../state/selectors/iotDevice';
import helpers from '../../utils/helpers';
import {AppButton} from '../Button';
import InternetAndDeviceTrackButton from '../Button/ConnectionAndDeviceTrackButton/InternetAndDeviceTrackButton';
import {Article} from '../DataDisplay';
import {FirmwareUpdateBlueIcon} from '../Icons';
import FirmwareReleaseNotesChanges from './FirmwareReleaseNotesChanges';

const FirmwareReleaseNotesArticle = ({onClick, onCancel}) => {
    const isDeviceReady = useSelector(selectIsDeviceReady);
    const deviceName = useSelector(makeSelectDeviceName());

    const localizedStrings = getLocalizedStrings();

    const onUpdateClick = () => {
        helpers.runFunction(onClick);
        appRouterService.forwardToUpdateSummaryPage();
    };

    return (
        <Article
            icon={<FirmwareUpdateBlueIcon className='h-16 w-16' />}
            titleClassName='text-28 mt-4'
            titleText={localizedStrings.formatString(
                localizedStrings[localizationKeys.FIRMWARE_MODAL_VIEW_FWU_CHANGES_124_4_4_TITLE],
                deviceName
            )}
            descriptionText={localizedStrings.formatString(
                localizedStrings[localizationKeys.FIRMWARE_MODAL_VIEW_FWU_CHANGES_124_4_4_DESCRIPTION],
                deviceName
            )}
        >
            <FirmwareReleaseNotesChanges />
            <InternetAndDeviceTrackButton
                isDeviceReady={isDeviceReady}
                button={AppButton}
                className='mt-8 max-w-[312px]'
                primary
                light
                onClick={onUpdateClick}
            >
                {localizedStrings[localizationKeys.FIRMWARE_MODAL_VIEW_UPDATE_BUTTON]}
            </InternetAndDeviceTrackButton>
            {onCancel && (
                <AppButton tertiary className='mt-3 text-center md:mt-4' onClick={onCancel}>
                    {localizedStrings[localizationKeys.FIRMWARE_MODAL_VIEW_SKIP_UPDATE_BUTTON]}
                </AppButton>
            )}
        </Article>
    );
};

export default FirmwareReleaseNotesArticle;
